// components/FeatureSection.jsx
import React from "react";
import "./featuresection.css";

const CuisineFeatureSection = () => {
  return (
    <section className="feature-wrapper">
      <div className="image-container">
        <img src="/Images/best coffee shop mandurah.webp" alt="Cafe" className="animated-image" loading="lazy"/>
        <div className="circle yellow"></div>
        <div className="circle white"></div>
        <div className="sb-experience">
          <div className="sb-exp-content">
            <p className="sb-h1 sb-mb-10">
              {" "}
              <span> 100 </span>
            </p>
            <p class="sb-h3">
              {" "}
              <span> Happy Customer </span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-container">
        {/* <h2>We are doing more than you expect</h2> */}

        <div className="feature-block">
          {/* <span className="monoton">01</span> */}
          <div>
            <h3>Discover the Best Indian Cuisine in Mandurah</h3>
            <p>
              Experience rich and aromatic Indian Cuisine in Mandurah at our
              beautifully located Mandurah Cafe. From creamy Butter Chicken to
              spicy Biryani and Tandoori delights, our menu showcases the
              diverse culinary traditions of India in every bite.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">02</span> */}
          <div>
            {/* <h3>Fresh, organic ingredients</h3> */}
            <p>
              Our chefs specialize in bringing authentic Indian flavors to the
              heart of Mandurah. We offer both vegetarian and non-vegetarian
              Indian cuisine, including vegan and gluten-free options for every
              guest. Every dish is a blend of tradition, spice, and soul.
            </p>
          </div>
        </div>

        <div className="feature-block">
          {/* <span className="monoton">03</span> */}
          <div>
            {/* <h3>Own fast delivery</h3> */}
            <p>
              Searching for the best Indian Cuisine near Mandurah? Mandurah Cafe
              invites you to savor flavorful curries, fresh naan, and hearty
              rice dishes made with love and authenticity. Come in today and
              enjoy a dining experience that feels just like home.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CuisineFeatureSection;
